import { Button } from "react-bootstrap";
import { useApp } from "./AppProvider"

export const customCtrlDef = {
    toString: async ({ def, defaultValue }) => {
        return def.text || def.href ? `${def.text} ${def.href}` : defaultValue;
    },
    def: (t, tools) => ({
        form: [{
            borderless: true,
            rows: [
                [
                    { type: "text", field: "text", label: t('text'), required: true }
                ],
                [
                    { type: "text", field: "href", label: "href", required: true }
                ]
            ]
        }]
    }),
    control: ({ def, ...props }) => <HyperLink href={def.href} {...props}>{def.text}</HyperLink>
}

const HyperLink = ({ href, children, target = '_blank', rel = 'noreferrer', hideLabel, placeholder }) => {
    const { isApp, emit } = useApp();

    return isApp ? <Button variant="link" onClick={() => emit('openURL', { url: href })}>{children}</Button> : <a href={href} target={target} rel={rel}>{children}</a>
}

export default HyperLink;